import axios from "axios";
import { forceLogout } from "../contexts/AuthContext";

const api = axios.create({
  baseURL: "https://youtubereader.api.adsctv.net",
});

/* =========================
   REQUEST INTERCEPTOR
========================= */
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("adm_panel_token");

  if (token) {
    config.headers = {
      ...(config.headers || {}),
      Token: token,
    };
  }

  return config;
});

/* =========================
   RESPONSE INTERCEPTOR
========================= */
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const currentPath = window.location.pathname;

    // 🔥 ONLY logout if NOT on login page
    if (status === 401) {
      console.warn("401 detected");

      if (!currentPath.includes("/login")) {
        console.warn("→ triggering logout");
        forceLogout();
      } else {
        console.warn("→ ignored (already on login page)");
      }
    }

    return Promise.reject(err);
  }
);

export default api;